import React from "react";
import PercentageBar from "./PercentageBar";
type Props = {
  value: number;
  title?: string;
  barColor: string;
  titleJustify?: "start" | "end" | "center";
};

const ProgressBar = (props: Props) => {
  const { value } = props;
  return <PercentageBar value={value} color={props.barColor} />;
};
export default ProgressBar;
